import React, { useEffect } from "react";
import { drawError } from "./utils";
import { Button, Modal } from "antd-mobile";
import Cookies from "js-cookie";
const autobahn = window.autobahn;

let bouncing = 0;
let last_call = "";

var msgpser = new autobahn.serializer.MsgpackSerializer();
var jsonser = new autobahn.serializer.JSONSerializer();




const runCall = (_path, _params, _callback) => {



    const s = Date.now();
    window.ses.call(_path, [], _params).then(
        function (res) {

            if (window?.maintenance_mode && typeof window?.maintenance_mode?.close === 'function') {
                window.maintenance_mode.close();
                window.maintenance_mode = null;
                window.location.reload();
                return;
            }


            const e = Date.now(); // End the timer
            const ms = e - s
            last_call = "";
            console.log("%c pubCall: " + _path, "color:yellow;", "(" + ms + "ms)", { call: _params, result: res });
            _callback(true, res);
        }
    ).catch(
        function (res) {
            last_call = "";
            console.log("%c pubCall: " + _path, "color:red;", "(" + res.error + ")", { call: _params, result: res });

            
            if (res.error === "com.bmo.maintenance") {

                if (window?.maintenance_mode) {
                    return;
                }

                let notice = <>Bookmanager is currently set to <strong>maintenance mode</strong>, and all current functions are temporarily unavailable. <div className="shim" /><div className="shim" /><div className="shim" /></>;
                let color = "var(--text-orange)";
                let message;
                switch (res?.kwargs?.message) {
                    case "Backup is in queue/processing":
                        color = "#C19C00"
                        message = <>Your backup is currently being processed. Please wait as we work on importing. It should only take a few minutes. <div className="shim" /><div className="shim" /><div className="shim" /></>;

                        break;
                    case "Store is in maintenance mode":
                        color = "#FF8418"
                        message = <>Oh no, something seems to have gone wrong! Please send a backup in order to use BMO again. If this keeps happening, please contact Bookmanager support for assistance. <div className="shim" /><div className="shim" /><div className="shim" /></>;

                        break;
                    case "Store removed from processing":
                        color = "#E70D3D"
                        message = <>Oh shoot, something went wrong! Please contact Bookmanager support to help resolve this issue. <div className="shim" /><div className="shim" /><div className="shim" /></>;
                        break;
                    default:

                }

                window.maintenance_mode = Modal.show({
                    title: "Maintenance mode",
                    bodyStyle: { backgroundColor: color },
                    content: <>{notice}{message}<div className="shim" /><div className="shim" /><div className="shim" /><Button onClick={() => {
                        Cookies.set("workstation", null, { expires: 14 })
                        window.history.replaceState(null, '', '/');
                        window.location.reload();
                    }}>Change Location</Button></>,
                });

            } else if (res.error === "com.bmo.seat_issue") {
                drawError(<>All seats have been allocated. <div className="shim" /><div className="shim" />For immediate assistance, please contact Bookmanager support. <div className="shim" /><div className="shim" />We apologize for any inconvenience.</>, "Reload", () => { window.location.reload() }, "Seat issue", false)
            } else {
                _callback(false, res);
            }
        }
    )
}


export const pubCall = (_method = "", _params = {}, _callback = () => { }, debounce = 0) => {
    if (!window.ses) {
        console.log("No pubsub sesison")
        return
    }

    if (!window.can_call) {
        return;
    }

    _params.is_mobile = true;

    let _path = "com." + window.credentials.store_id + "." + _method;

    let obj = {
        "action": _path,
        "params": _params,
    }

    // Stop double calls...
    if ((last_call) && JSON.stringify(obj) === last_call) {
        console.log("is sending...")
        return;
    }
    last_call = JSON.stringify(obj);


    _params.session_id = window.credentials.ticket;
    _params.subscription_id = parseInt(window.subscription_id);



    if (debounce) {

        if (!bouncing) {
            runCall(_path, _params, _callback);
            bouncing = 1;
            console.log("instant call")
            console.log(obj)
        }
        clearTimeout(bouncing);
        bouncing = setTimeout(() => {
            console.log("delay call")
            console.log(obj);
            runCall(_path, _params, _callback);
            bouncing = 0;
        }, debounce)



    } else {
        console.log(obj);
        runCall(_path, _params, _callback);
    }
}


// export const pubSub = (_uri = "", _params = {}, _callback = () => { }) => {
//     if (!window.ses) {
//         console.log("No pubsub sesison");
//         return
//     }

//     let _path = "com." + window.credentials.store_id + "." + _uri;

//     window.ses.subscribe(_path, _callback).then(() => {
//         console.log("subscribed to " + _uri);
//     });

// }

export const pubSub = (_uri = "", _params = {}, _callback = () => { }) => {
    if (!window.ses) {
        console.error("No pubsub session");
        return;
    }

    // Initialize the subscribed array if not already set
    if (!Array.isArray(window.subscribed)) {
        window.subscribed = [];
    }

    // Generate the subscription path
    const _path = `com.${window.credentials?.store_id ?? "default"}.${_uri}`;

    // Check if already subscribed
    if (window.subscribed.includes(_path)) {
        return;
    }

    // Add to subscribed list and subscribe
    window.subscribed.push(_path);
    window.ses.subscribe(_path, typeof _callback === "function" ? _callback : () => { })
        .then(() => {
            console.log(`Successfully subscribed to ${_uri}`);
        })
        .catch((error) => {
            console.error(`Failed to subscribe to ${_uri}:`, error);
            // Remove from subscribed list on failure
            window.subscribed = window.subscribed.filter(path => path !== _path);
        });
};





const PubSub = (props) => {

    const { globals = {}, setGlobals = () => { } } = props;

    useEffect(() => {

        if (!globals.connect) {
            return;
        }

        document.body.style.webkitTouchCallout = 'none'; // Disable text selection for iOS Safari
        document.body.style.webkitUserSelect = 'none'; // Disable text selection for iOS Safari

        // Tobias's auth thing... 
        const onChallenge = (_session, _method, _extra) => {
            console.log("autheticating " + _method);
            if (_method === "ticket") { return window.credentials.ticket; }
            setGlobals({ ...globals, "status": "error" });
            console.log("Can't authenticate using '" + _method + "'");
        }

        // Connection
        const connection = new autobahn.Connection({
            url: window.credentials.socket_url,
            realm: 'bookmanager',
            authmethods: ["ticket"],
            authid: window.credentials.store_id.toString(),
            onchallenge: onChallenge,
            serializers: [msgpser, jsonser]
        });

        // Open (Set window vars and create subscriptions)
        const onOpen = (session) => {
            window.ses = session;
            window.credentials.subscription_id = session.id;
            window.subscription_id = session.id;
            setGlobals({ ...globals, "status": "authenticating", "ready": true });
            console.log("open");
        };

        // Function to handle when the connection is closed
        const onClose = (reason, details) => {
            console.log('WebSocket connection closed:', reason, details);
            setGlobals({ ...globals, "status": "error" });
        };

        // Set up event listeners
        connection.onopen = onOpen;
        connection.onclose = onClose;

        window.disconnectWamp = () => {
            if (connection.isOpen) {
                connection.close();
                console.log('Connection closed globally');
            }
        };

        window.reconnectWamp = () => {
            if (!connection.isOpen) {
                connection.open();
                console.log('Connection reopened globally');
            }
        };


        // Open the connection
        connection.open();

        // Cleanup function to close the connection when the component unmounts
        return () => {
            window.ses = null;
            window.subscribed = [];
            window.credentials.subscription_id = "";

            // connection could be already closed...
            try {
                connection.close();
            } catch (e) {

            }

        };
    }, [globals.connect]);  // Run the effect only once when the component mounts

    return (<></>);
};

export default PubSub;